import { Link } from 'react-router'
import video from './video.mp4'
import poster from './poster.jpg'

export const HeroSection: React.FC = () => {
  return (
    <section className="relative">
      <div className="w-full h-[85vh] md:h-[90vh] relative overflow-hidden">
        <video src={video} poster={poster} autoPlay muted loop playsInline className="w-full h-full object-cover" />
        <div className="absolute inset-0 flex items-end justify-center pb-16 md:pb-24 px-5">
          <div className="max-w-2xl w-full text-center">
            <h1
              style={{ textShadow: '0 2px 12px rgba(0,0,0,0.4)' }}
              className="text-[26px] md:text-[44px] font-medium leading-[1.8] md:leading-[1.7] text-white"
            >
              部屋が一気に垢抜ける
              <br />
              季節の枝もの定期便
            </h1>
            <p style={{ textShadow: '0 1px 6px rgba(0,0,0,0.3)' }} className="mt-5 text-[17px] text-white/80 tracking-[0.06em] leading-[1.8]">
              月額 3,520円（送料無料）
            </p>
            <Link
              reloadDocument
              to="/subscription/branch/new"
              className="inline-block mt-10 px-12 py-5 bg-accent text-white text-[14px] font-medium tracking-wide rounded-full hover:opacity-90 transition-opacity"
            >
              定期便を始める
            </Link>
            <p style={{ textShadow: '0 1px 6px rgba(0,0,0,0.3)' }} className="mt-3 text-[13px] text-white/80 tracking-wider">
              違約金なし・いつでも解約OK
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
